<template>
  <z-form ref="form" class="w-100">
    <base-modal>
      <z-form-group class="row align-items-start">
        <div class="col-3 text-right">
          {{ $t('autocaller_v2.campaign.field.operator') }}
        </div>
        <z-form-input class="col-9">
          <select-operators
            v-model="form.operator_ids"
            :all_operators="all_operators"
            :filtered_operators="filtered_operators"
          />
        </z-form-input>
      </z-form-group>
      <i-button slot="footer-ok" size="large" type="success" @click="remove(), save()">
        {{ $t('shared.component.button.save') }}
      </i-button>
    </base-modal>
  </z-form>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import SelectOperators from './campaigns-input-operators';
  import intersectionBy from 'lodash-es/intersectionBy';
  import axios from 'axios';

  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  import { OperatorsService } from '@autocaller_v2/services/OperatorsService';

  export default {
    components: { BaseModal, SelectOperators },
    props: {
      campaign_id: {
        type: [Number, String],
        required: true
      }
    },
    data: () => ({
      form: {
        operator_ids: []
      },
      all_operators: [],
      exist_operators: [],
      ex_operators: []
    }),
    computed: {
      filtered_operators() {
        return this.exist_operators.length ? this.exist_operators.map((o) => o.id) : '';
      },
      add_operators() {
        return this.form.operator_ids.filter((obj) => this.filtered_operators.indexOf(obj) == -1);
      },
      remove_operators() {
        return this.ex_operators.filter((value) => !this.form.operator_ids.includes(value));
      }
    },
    created() {
      // OperatorsService.getList({ items_per_page: 500 }).then((response) => {
      //   this.all_operators = response.data || [];
      // });

      // CampaignsService.getOperators(this.campaign_id).then((response) => {
      //   this.form.operator_ids = intersectionBy(this.all_operators, response, 'id').map(
      //     (i) => i.id
      //   );
      //   this.exist_operators = response || [];
      // });

      axios
        .all([
          OperatorsService.getList({ items_per_page: 500 }),
          CampaignsService.getOperators(this.campaign_id)
        ])
        .then(
          axios.spread((all_operators, selected) => {
            this.all_operators = all_operators.data;
            this.form.operator_ids = intersectionBy(this.all_operators, selected, 'id').map(
              (i) => i.id
            );

            this.ex_operators = this.form.operator_ids;
          })
        );
    },
    methods: {
      remove() {
        for (let key in this.remove_operators) {
          this.$refs.form.validate().then((is_valid) => {
            if (is_valid) {
              CampaignsService.removeOperator(
                this.campaign_id,
                this.remove_operators[key]
              ).then((res) => this.$emit('success', res));
            }
          });
        }
      },
      save() {
        for (let key in this.add_operators) {
          this.$refs.form.validate().then((is_valid) => {
            if (is_valid) {
              CampaignsService.addOperator(this.campaign_id, {
                operator_id: this.add_operators[key]
              }).then((res) => this.$emit('success', res));
            }
          });
        }
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.$emit('success');
          }
        });
      }
    }
  };
</script>
